import React from 'react';
import { useObserver } from 'mobx-react';
import userStore from 'store/user';
import Routes from './routes';
import { Layout, Spin } from 'antd';
import { LoadingOutlined, CopyrightOutlined } from '@ant-design/icons';
import SideMenu from './side-menu';
import { StyledLayout } from './styled';
import { Notification } from 'components/notification';
import { countryCode, termsServiceUrl, ECountryCode } from '@/lib/locale';
import { useModuleTranslation } from '@/i18n/translation';

const { Content, Footer } = Layout;
const Main = () => {
  const t = useModuleTranslation('common');
  const antIcon = <LoadingOutlined style={{ fontSize: 30 }} />;
  const d = new Date();

  return useObserver(() =>
    userStore.loading ? (
      <Spin
        indicator={antIcon}
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingBottom: 100,
        }}
      />
    ) : (
      <>
        <StyledLayout>
          <Notification />
          <SideMenu />
          <Layout>
            <Content
              style={{
                margin: '24px 16px',
                padding: 16,
                background: '#fff',
                overflow: 'auto',
                wordBreak: 'break-word',
              }}>
              <Routes />
            </Content>
            <Footer style={{ textAlign: 'center', padding: '15px 50px' }}>
              <CopyrightOutlined />
              &nbsp;{d.getFullYear()} Atome{' '}
              <a href={termsServiceUrl} target="_blank" rel="noopener noreferrer">
                {t.ts}
              </a>
              {countryCode === ECountryCode.ID && userStore.userProfile.contract && (
                <a
                  style={{ marginLeft: '20px' }}
                  href={userStore.userProfile.contract}
                  target="_blank"
                  rel="noopener noreferrer">
                  {t.mc}
                </a>
              )}
            </Footer>
          </Layout>
        </StyledLayout>
      </>
    ),
  );
};

export default Main;
